<template lang='pug'>
ul.feature
  li.feature__item(
    v-for="item in block.items"
    :key="item.subtitle"
    )
    h4.feature__title(v-html="item.subtitle")
    span.feature__text(v-html="item.text")
</template>

<script>
export default {
  name: 'FeatureComponent',
  props: {
    block: {
      type: Object,
      default: () => {},
    }
  },
}
</script>

<style lang='scss' scoped>
.feature {
  &__item {
    margin-bottom: 3.6rem;
    padding-left: 7.38rem;
    background: url('~/assets/images/services/feature.svg') no-repeat;
    min-height: 97px;

    @media screen and (max-width: 1024px) {
      padding-left: 3.68rem;
      background-size: 30px 30px;
    }
  }

  &__title {
    font-weight: bold;
    margin-bottom: 0.75rem;
    font-size: 1rem;
    height: calc(1rem * 1.2);

    @media screen and (max-width: 1024px) {
      height: auto;
    }
  }
}
</style>
